"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ScopedUtilityClassProvider", {
    enumerable: true,
    get: function() {
        return ScopedUtilityClassProvider;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _utilityClasses = require("../util/utilityClasses");
const _Theme = require("./Theme");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const random = "c0179c41-ba25-4028-add7-c483e217345c";
let instance = 0;
const ScopedUtilityClassProvider = (param)=>{
    let { children } = param;
    const theme = (0, _Theme.useTheme)();
    // `styled-jsx` won't process `:global` directives in styles we construct by
    // string concatenation like in `utilityClasses`. Give this container element
    // a unique class name so we can make these styles global.
    const className = (0, _react.useMemo)(()=>"utility-class-root-".concat(random, "-").concat(instance++), []);
    const utilityClasses = (0, _react.useMemo)(()=>(0, _utilityClasses.utilityClasses)(theme, ".".concat(className)), [
        theme,
        className
    ]);
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "bf6ea842ddb6ed80",
                [
                    utilityClasses,
                    className,
                    theme.fontSize
                ]
            ]
        ]) + " " + (className || "")
    }, children), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "bf6ea842ddb6ed80",
        dynamic: [
            utilityClasses,
            className,
            theme.fontSize
        ]
    }, "".concat(utilityClasses, " .").concat(className, "{font-size:").concat(theme.fontSize, "}")));
};

//# sourceMappingURL=ScopedUtilityClassProvider.js.map